/* custom section (collection-list) */

$(".c-collection-slider").owlCarousel({
  loop: true,
  margin: 100,
  dots: false,
  nav: true,
  autoplay: true,
  smartSpeed: 1000,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      margin: 10,
      items: 2, // 1 item for screens smaller than 768px
    },
    768: {
      margin: 30,
      items: 2, // 2 items for screens between 768px and 992px
    },
    992: {
      items: 3, // 3 items for screens larger than 992px
    },
  },
});

/* end custom section (collection-list) */

/* 1 2 3 section */

$(".c-slider").owlCarousel({
  loop: true,
  margin: 10,
  dots: true,
  smartSpeed: 3000,
  items: 1, // Add this line for dots
  autoplay: true, // Add this line for autoplay
  autoplayTimeout: 5000, // Adjust the autoplay timeout (optional)
  autoplayHoverPause: true, // Pause on hover (optional)
});

/* end 1 2 3 */
